// 行业类别

const industryOption = [
    {
        value: "互联网/AI",
        id: 1,
        children: [
            {
                value: "互联网",
                id: ""
            }, {
                value: "电子商务",
                id: ""
            }, {
                value: "计算机软件",
                id: ""
            }, {
                value: "生活服务(O2O)",
                id: ""
            }, {
                value: "企业服务",
                id: ""
            }, {
                value: "医疗健康",
                id: ""
            }, {
                value: "游戏",
                id: ""
            }, {
                value: "社交网络与媒体",
                id: ""
            }, {
                value: "人工智能",
                id: ""
            }, {
                value: "云计算",
                id: ""
            }, {
                value: "在线教育",
                id: ""
            }, {
                value: "计算机服务",
                id: ""
            }, {
                value: "大数据",
                id: ""
            }, {
                value: "广告营销",
                id: ""
            }, {
                value: "物联网",
                id: ""
            }, {
                value: "新零售",
                id: ""
            }, {
                value: "信息安全",
                id: ""
            },
        ]

    }, {
        value: "电子/通信/半导体",
        id: "",
        children: [
            {
                value: "半导体芯片",
                id: "",
            }, {
                value: "电子/硬件开发",
                id: "",
            }, {
                value: "通信/网络设备",
                id: "",
            }, {
                value: "智能硬件/消费电子",
                id: "",
            }, {
                value: "运营商/增值服务",
                id: "",
            }, {
                value: "计算机硬件",
                id: "",
            },
        ]
    }, {
        value: "服务业",
        id: "",
        children: [
            {
                value: "餐饮",
                id: "",
            }, {
                value: "美容",
                id: "",
            }, {
                value: "美发",
                id: "",
            }, {
                value: "酒店/民宿",
                id: "",
            }, {
                value: "休闲/娱乐",
                id: "",
            }, {
                value: "运动/健身",
                id: "",
            }, {
                value: "保健/养生",
                id: "",
            }, {
                value: "家政服务",
                id: "",
            }, {
                value: "旅游/景区",
                id: "",
            }, {
                value: "婚庆/摄影",
                id: "",
            }, {
                value: "宠物服务",
                id: "",
            }, {
                value: "回收/维修",
                id: "",
            }, {
                value: "其他生活服务",
                id: "",
            },
        ]
    }, {
        value: "消费品/批发/零售",
        id: "",
        children: [
            {
                value: "批发/零售",
                id: "",
            }, {
                value: "进出口贸易",
                id: "",
            }, {
                value: "食品/饮料/烟酒",
                id: "",
            }, {
                value: "服装/纺织",
                id: "",
            }, {
                value: "家具/家居",
                id: "",
            }, {
                value: "家用电器",
                id: "",
            }, {
                value: "日化",
                id: "",
            }, {
                value: "珠宝/首饰",
                id: "",
            }, {
                value: "其他消费品",
                id: "",
            },
        ]
    }, {
        value: "房地产/建筑",
        id: "",
        children: [
            {
                value: "装修装饰",
                id: "",
            }, {
                value: "房屋建筑工程",
                id: "",
            }, {
                value: "土木工程",
                id: "",
            }, {
                value: "机电工程",
                id: "",
            }, {
                value: "物业管理",
                id: "",
            }, {
                value: "房地产中介/租赁",
                id: "",
            }, {
                value: "建筑材料",
                id: "",
            }, {
                value: "房地产开发经营",
                id: "",
            }, {
                value: "建筑设计",
                id: "",
            }, {
                value: "建筑工程咨询服务",
                id: "",
            }, {
                value: "土地与公共设施管理",
                id: "",
            },
        ]
    }, {
        value: "教育培训",
        id: "",
        children: [
            {
                value: "培训/辅导机构",
                id: "",
            }, {
                value: "职业培训",
                id: "",
            }, {
                value: "学前教育",
                id: "",
            }, {
                value: "学校/学历教育",
                id: "",
            }, {
                value: "学术/科研",
                id: "",
            },
        ]
    }, {
        value: "广告/传媒/文化/教育",
        id: "",
        children: [
            {
                value: "文化艺术/娱乐",
                id: "",
            }, {
                value: "体育",
                id: "",
            }, {
                value: "广告/公关/会展",
                id: "",
            }, {
                value: "广播/影视",
                id: "",
            }, {
                value: "新闻/出版",
                id: "",
            },
        ]
    }, {
        value: "制造业",
        id: "",
        children: [
            {
                value: "通用设备",
                id: "",
            }, {
                value: "专用设备",
                id: "",
            }, {
                value: "电气机械/器材",
                id: "",
            }, {
                value: "金属制品",
                id: "",
            }, {
                value: "非金属矿物制品",
                id: "",
            }, {
                value: "橡胶/塑料制品",
                id: "",
            }, {
                value: "化学原料/化学制品",
                id: "",
            }, {
                value: "仪器仪表",
                id: "",
            }, {
                value: "自动化设备",
                id: "",
            }, {
                value: "印刷/包装/造纸",
                id: "",
            }, {
                value: "铁路/船舶/航空/航天制造",
                id: "",
            }, {
                value: "计算机/通信/其他电子产品",
                id: "",
            }, {
                value: "新材料",
                id: "",
            }, {
                value: "其他制造业",
                id: "",
            },
        ]
    }, {
        value: "专业服务",
        id: "",
        children: [
            {
                value: "咨询",
                id: "",
            }, {
                value: "财务/审计/税务",
                id: "",
            }, {
                value: "人力资源服务",
                id: "",
            }, {
                value: "法律",
                id: "",
            }, {
                value: "检测/认证/知识产权",
                id: "",
            }, {
                value: "翻译",
                id: "",
            }, {
                value: "其他专业服务",
                id: "",
            },
        ]
    }, {
        value: "制药/医疗",
        id: "",
        children: [
            {
                value: "医疗服务",
                id: "",
            }, {
                value: "医美服务",
                id: "",
            }, {
                value: "医疗器械",
                id: "",
            }, {
                value: "IVO",
                id: "",
            }, {
                value: "生物/制药",
                id: "",
            }, {
                value: "医药批发零售",
                id: "",
            }, {
                value: "医疗研发外包",
                id: "",
            },
        ]
    }, {
        value: "汽车",
        id: "",
        children: [
            {
                value: "新能源汽车",
                id: "",
            }, {
                value: "汽车智能网联",
                id: "",
            }, {
                value: "汽车经销商",
                id: "",
            }, {
                value: "汽车后市场",
                id: "",
            }, {
                value: "汽车研发/制造",
                id: "",
            }, {
                value: "汽车零部件",
                id: "",
            }, {
                value: "摩托车/自行车制造",
                id: "",
            },
        ]
    }, {
        value: "交通运输/物流",
        id: "",
        children: [
            {
                value: "即时配送",
                id: "",
            }, {
                value: "快递",
                id: "",
            }, {
                value: "公路物流",
                id: "",
            }, {
                value: "同城货运",
                id: "",
            }, {
                value: "跨境物流",
                id: "",
            }, {
                value: "装卸搬运和仓储业",
                id: "",
            }, {
                value: "客运服务",
                id: "",
            }, {
                value: "港口/铁路/公路/机场",
                id: "",
            },
        ]
    }, {
        value: "能源/化工/环保",
        id: "",
        children: [
            {
                value: "光伏",
                id: "",
            }, {
                value: "储能",
                id: "",
            }, {
                value: "动力电池",
                id: "",
            }, {
                value: "风电",
                id: "",
            }, {
                value: "其他新能源",
                id: "",
            }, {
                value: "环保",
                id: "",
            }, {
                value: "化工",
                id: "",
            }, {
                value: "电力/热力/燃气/水利",
                id: "",
            }, {
                value: "石油/石化",
                id: "",
            }, {
                value: "矿产/地质",
                id: "",
            }, {
                value: "采掘/冶炼",
                id: "",
            },
        ]
    }, {
        value: "金融",
        id: "",
        children: [
            {
                value: "互联网金融",
                id: "",
            }, {
                value: "银行",
                id: "",
            }, {
                value: "投资/融资",
                id: "",
            }, {
                value: "证券/期货",
                id: "",
            }, {
                value: "基金",
                id: "",
            }, {
                value: "保险",
                id: "",
            }, {
                value: "租赁/拍卖/典当/担保",
                id: "",
            }, {
                value: "信托",
                id: "",
            }, {
                value: "财富管理",
                id: "",
            }, {
                value: "其他金融业",
                id: "",
            },
        ]
    }, {
        value: "政府/非盈利机构/其他",
        id: "",
        children: [
            {
                value: "农/林/牧/渔",
                id: "",
            }, {
                value: "非盈利机构",
                id: "",
            }, {
                value: "政府/公共事业",
                id: "",
            }, {
                value: "其他行业",
                id: "",
            },
        ]
    },
]

/**
 * 1. 递归格式化单个JSON节点（处理层级结构）
 * @param {Object} item - 原始JSON中的单个节点（含code、name、subLevelModelList等字段）
 * @returns {Object} 格式化后的节点（统一子节点字段为children，只保留核心字段）
 */
function formatJsonNode(item) {
    // 提取核心字段（可根据需求增减，如保留flag、sort等）
    const formattedNode = {
        code: item.code,       // 编码
        name: item.name,       // 名称
        children: []           // 统一子节点字段名为children（原subLevelModelList）
    };

    // 递归处理子层级（如果存在subLevelModelList）
    if (item.subLevelModelList && Array.isArray(item.subLevelModelList) && item.subLevelModelList.length > 0) {
        formattedNode.children = item.subLevelModelList.map(subItem => formatJsonNode(subItem));
    }

    return formattedNode;
}

/**
 * 2. 整体格式化JSON数据（入口函数）
 * @param {Object|Array} originalData - 原始JSON数据（可能是单个对象或对象数组）
 * @returns {Array} 完全格式化后的JSON数组（顶层统一为数组，便于处理）
 */
function formatJsonData(originalData) {
    // 确保顶层数据是数组（如果原始数据是单个对象，转为数组）
    const originalList = Array.isArray(originalData) ? originalData : [originalData];

    // 批量处理所有顶层节点
    return originalList.map(item => formatJsonNode(item));
}

/**
 * 3. 将格式化后的数据导出为JSON文件（浏览器端下载）
 * @param {Object|Array} formattedData - 格式化后的JSON数据
 * @param {string} fileName - 导出文件的名称（默认：formatted_data.json）
 */
function exportJsonFile(json, fileName = 'formatted_data.json') {
    const formattedData = formatJsonData(json.config);
    console.log("formattedData",formattedData);
    
    try {
        // 将JSON数据转为带缩进的字符串（便于阅读，缩进2个空格）
        const jsonString = JSON.stringify(formattedData);

        // 创建Blob对象（二进制数据容器）
        const blob = new Blob([jsonString], { type: 'application/json;charset=utf-8' });

        // 创建下载链接
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName; // 文件名

        // 触发下载（模拟点击链接）
        document.body.appendChild(a);
        a.click();

        // 清理资源（避免内存泄漏）
        document.body.removeChild(a);
        URL.revokeObjectURL(url);

        console.log(`✅ JSON文件导出成功！文件名：${fileName}`);
    } catch (error) {
        console.error('❌ JSON文件导出失败：', error);
        alert('文件导出失败，请检查数据格式！');
    }
}

export { industryOption }